var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_mb-md-50 _mb-sm-30"},[_c('p',{staticClass:"-spnone"},[_vm._v("アップロード時のご確認事項をお読みいただき、「ファイルを選択する」を押してアップロードしてください。")]),_vm._v(" "),_c('p',{staticClass:"-pcnone"},[_vm._v("アップロード時のご確認事項をお読みいただき、「撮影する」を押してアップロードしてください。")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5294d80e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/TxtTop.vue
// module id = null
// module chunks = 